import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuoteRequestFilters = ({ filters, onFiltersChange, onRefresh }) => {
    const handleFilterChange = (key, value) => {
        onFiltersChange({ ...filters, [key]: value });
    };

    const handleClearFilters = () => {
        onFiltersChange({
            status: '',
            requestType: '',
            search: ''
        });
    };

    const hasActiveFilters = filters?.status || filters?.requestType || filters?.search;

    return (
        <div className="bg-card border border-border rounded-lg p-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Search */}
                <div className="md:col-span-2">
                    <div className="relative">
                        <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                        <input
                            type="text"
                            placeholder="Rechercher par nom, email ou référence..."
                            value={filters?.search}
                            onChange={(e) => handleFilterChange('search', e?.target?.value)}
                            className="w-full pl-10 pr-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-background text-foreground"
                        />
                    </div>
                </div>

                {/* Status Filter */}
                <div>
                    <select
                        value={filters?.status}
                        onChange={(e) => handleFilterChange('status', e?.target?.value)}
                        className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-background text-foreground"
                    >
                        <option value="">Tous les statuts</option>
                        <option value="pending">En attente</option>
                        <option value="contacted">Contacté</option>
                        <option value="accepted">Accepté</option>
                        <option value="rejected">Refusé</option>
                        <option value="completed">Terminé</option>
                    </select>
                </div>

                {/* Type Filter */}
                <div>
                    <select
                        value={filters?.requestType}
                        onChange={(e) => handleFilterChange('requestType', e?.target?.value)}
                        className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-background text-foreground"
                    >
                        <option value="">Tous les types</option>
                        <option value="vehicle_booking">Location de Véhicule</option>
                        <option value="property_rental">Location Immobilière</option>
                    </select>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-3 mt-4">
                <Button
                    variant="outline"
                    size="sm"
                    iconName="RefreshCw"
                    iconPosition="left"
                    onClick={onRefresh}
                >
                    Actualiser
                </Button>

                {hasActiveFilters && (
                    <Button
                        variant="ghost"
                        size="sm"
                        iconName="X"
                        iconPosition="left"
                        onClick={handleClearFilters}
                    >
                        Effacer les filtres
                    </Button>
                )}
            </div>
        </div>
    );
};

export default QuoteRequestFilters;
